import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Zap } from 'lucide-react';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }
    login({ email: formData.email, firstName: 'Customer', lastName: '' });
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      
      <main className="pt-40 pb-20">
        <div className="max-w-md mx-auto px-6">
          <div className="text-center mb-10">
            <div className="w-16 h-16 bg-gradient-to-br from-vybe-600 to-vybe-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Zap className="w-8 h-8 text-white" />
            </div>
            <h1 className="font-display text-3xl text-white mb-2">Welcome Back</h1>
            <p className="text-slate-400">Sign in to your account</p>
          </div>
          
          <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="p-3 bg-coral-500/10 border border-coral-500/30 text-coral-400 text-sm rounded-xl">
                  {error}
                </div>
              )}
              
              <div>
                <Label className="text-sm text-slate-300 font-medium">Email</Label>
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="mt-2 bg-slate-900 border-slate-700 text-white placeholder-slate-500 focus:ring-vybe-500 focus:border-vybe-500 rounded-xl"
                  placeholder="your@email.com"
                />
              </div>
              
              <div>
                <Label className="text-sm text-slate-300 font-medium">Password</Label>
                <Input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="mt-2 bg-slate-900 border-slate-700 text-white placeholder-slate-500 focus:ring-vybe-500 focus:border-vybe-500 rounded-xl"
                  placeholder="••••••••"
                />
              </div>
              
              <div className="flex items-center justify-end">
                <Link to="/forgot-password" className="text-sm text-vybe-400 hover:text-vybe-300 transition-colors">
                  Forgot password?
                </Link>
              </div>
              
              <button 
                type="submit" 
                className="w-full py-4 bg-gradient-to-r from-vybe-600 to-vybe-500 hover:from-vybe-500 hover:to-vybe-400 text-white font-bold rounded-xl transition-all shadow-button"
              >
                Sign In
              </button>
            </form>
          </div>
          
          <p className="text-center mt-6 text-slate-400 text-sm">
            Don't have an account?{' '}
            <Link to="/register" className="text-vybe-400 font-medium hover:text-vybe-300 transition-colors">
              Create one
            </Link>
          </p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LoginPage;
